module.exports = __webpack_public_path__ + "img/newsImg11.e7fc2d1f.png";